import { defineStore } from 'pinia'
import { ref, watch } from 'vue'

export const useAppStore = defineStore('app', () => {
  // Theme state
  const theme = ref<'light' | 'dark'>('light')
  
  // Modal states
  const uploadModalVisible = ref(false)
  const aiAssistantVisible = ref(false)
  
  // Search type state
  const activeSearchType = ref<'mixed' | 'image' | 'video' | 'audio' | 'document'>('mixed')
  
  // Initialize theme from localStorage
  const initTheme = () => {
    const savedTheme = localStorage.getItem('app-theme') as 'light' | 'dark' | null
    if (savedTheme) {
      theme.value = savedTheme
    } else if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
      theme.value = 'dark'
    }
    applyTheme()
  }
  
  // Apply theme to document
  const applyTheme = () => {
    if (theme.value === 'dark') {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
  }
  
  // Toggle theme
  const toggleTheme = () => {
    theme.value = theme.value === 'light' ? 'dark' : 'light'
    localStorage.setItem('app-theme', theme.value)
    applyTheme()
  }
  
  // Watch theme changes
  watch(theme, () => {
    applyTheme()
  })
  
  // Modal actions
  const openUploadModal = () => {
    uploadModalVisible.value = true
  }
  
  const closeUploadModal = () => {
    uploadModalVisible.value = false
  }
  
  const toggleAIAssistant = () => {
    aiAssistantVisible.value = !aiAssistantVisible.value
  }
  
  return {
    theme,
    uploadModalVisible,
    aiAssistantVisible,
    activeSearchType,
    initTheme,
    toggleTheme,
    openUploadModal,
    closeUploadModal,
    toggleAIAssistant
  }
})
